import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';

export const DetailInvoice = ({ data, privilege }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Invoice.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="billing">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Penagihan
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <ListHorizontal
              title="Customer"
              content={data?.customer?.name}
            />

            <ListHorizontal
              title="Penagihan Ke"
              content={data?.billing_to}
            />

            <ListHorizontal
              title="Alamat Penagihan"
              content={data?.billing_address}
            />

            <ListHorizontal
              title="Tanggal Penagihan"
              content={formatDate(data?.schedule_at, 'DD/MM/YYYY')}
            />

            <ListHorizontal
              title="Jatuh Tempo"
              content={formatDate(data?.due_at, 'DD/MM/YYYY')}
            />

            <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
            <ListHorizontal
              title="Dibuat Tanggal"
              content={formatDate(data?.created_at)}
            />

            {data?.note && (
              <ListHorizontal title="Catatan" content={data?.note} />
            )}
          </>
        )}
      </div>
    </section>
  );
};

export const DetailPayment = ({ data, privilege }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Invoice.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="payment">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Biaya
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            {privilege && (
              <>
                <ListHorizontal
                  title="Subtotal"
                  content={currencyFormat(data?.subtotal, 'IDR')}
                />
                <ListHorizontal
                  title="Diskon"
                  content={currencyFormat(data?.discount, 'IDR')}
                />
                <ListHorizontal
                  title="Total Biaya Tambahan"
                  content={currencyFormat(data?.additional_charges, 'IDR')}
                />
                {data?.ppn !== 0 && (
                  <ListHorizontal
                    title="PPn"
                    content={
                      <div className='d-flex flex-row'>
                        <div className='me-2'>{currencyFormat(data?.ppn_nominal, 'IDR')}</div>

                        <div className="title fw-semibold">{`(${data?.ppn} %)`}</div>
                      </div>
                    }
                  />
                )}
                <ListHorizontal
                  title="Total Penagihan"
                  content={currencyFormat(data?.total_charges, 'IDR')}
                />
                <ListHorizontal
                  title="Total Pembayaran"
                  content={currencyFormat(data?.total_paid, 'IDR')}
                />
                <ListHorizontal
                  title="Sisa Pembayaran"
                  content={currencyFormat(data?.total_charges - data?.total_paid, 'IDR')}
                />
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};
